import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          "flex h-9 w-full rounded-md",
          "bg-[hsl(var(--input))] border border-[hsl(var(--border))]",
          "px-3 py-2 text-sm text-foreground",
          "font-sans",
          "placeholder:text-muted-foreground/60",
          "transition-colors duration-[120ms]",
          "hover:border-[hsl(var(--border-strong))]",
          /* Foco em ouro para inputs financeiros, verde para demais */
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-[hsl(var(--gold)/0.5)]",
          "disabled:pointer-events-none disabled:opacity-40",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
